import React from 'react';
import { Announcement } from '../../config/announcements';

interface AnnouncementBannerProps {
  announcement: Announcement | null;
  onDismiss: () => void;
}

/**
 * Banner d'annonce arbitre
 *
 * - Overlay plein écran qui bloque toutes les interactions
 * - Banner affiché en haut de l'écran avec fond amber
 * - Cliquer n'importe où sur l'écran ferme l'annonce
 * - Supporte jusqu'à 3 lignes de texte
 */
export const AnnouncementBanner: React.FC<AnnouncementBannerProps> = ({
  announcement,
  onDismiss,
}) => {
  if (!announcement) return null;

  return (
    <div
      className="fixed inset-0 z-[60] cursor-pointer select-none"
      onClick={onDismiss}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onDismiss();
        }
      }}
      aria-label="Dismiss announcement"
    >
      {/* Banner en haut */}
      <div className="bg-amber-500/90">
        <div className="px-4 py-3 text-center text-black">
          {announcement.lines.map((line, index) => (
            <p key={index} className="text-2xl font-semibold text-black">
              {line}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};
